import {
  CLOVER_POTION_IDS,
  getCloverPotionById,
  getCloverTierLabel,
} from "../constants/cloverPotions";

export function CloverCelebrationNote({ cloverPotionId }) {
  const potion = getCloverPotionById(cloverPotionId);
  const tierLabel = getCloverTierLabel(cloverPotionId);
  if (!potion || !tierLabel) return null;

  const iconModifier =
    cloverPotionId === CLOVER_POTION_IDS.MAJEUR
      ? "game-progress-celebration__clover-icon--major"
      : "game-progress-celebration__clover-icon--minor";

  return (
    <p className="game-progress-celebration__clover">
      Oh… ça alors&nbsp;! Vous avez gagné une potion de trèfles {tierLabel}{" "}
      <img
        src={potion.image}
        alt={potion.name}
        className={`game-progress-celebration__clover-icon ${iconModifier}`}
        draggable={false}
      />{" "}
      ! Elle vous attend dans le catalogue des potions. Utilisez-la pour accéder à la
      roue&nbsp;!
    </p>
  );
}
